/*
 * KO Kitchen Studio loader.
 * Downloads the 3D studio (three.js and the kitchen engine) only when a 3D section comes near the
 * screen, or when the visitor presses Start, so pages stay fast for everyone who never scrolls there.
 */
(() => {
  if (window.koStudioLoader) return;
  window.koStudioLoader = true;
  const SELECTOR = '[data-ko-designer], [data-ko-showcase]';
  let studio;

  const start = (root) => {
    if (root.dataset.koLoading) return;
    root.dataset.koLoading = 'true';
    studio = studio || import(root.dataset.koApp);
    studio
      .then((m) => m.boot(root))
      .catch((e) => {
        console.error('[KO Studio]', e);
        root.classList.add('is-unsupported');
      });
  };

  const mount = (scope = document) => {
    scope.querySelectorAll(SELECTOR).forEach((root) => {
      if (root.dataset.koMounted) return;
      root.dataset.koMounted = 'true';
      if (root.dataset.autostart === 'click') {
        const btn = root.querySelector('[data-start]');
        if (btn) btn.addEventListener('click', () => start(root), { once: true });
        return;
      }
      if (!('IntersectionObserver' in window)) {
        start(root);
        return;
      }
      const io = new IntersectionObserver(
        (entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            io.disconnect();
            start(root);
          }
        },
        { rootMargin: '400px 0px' },
      );
      io.observe(root);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount());
  else mount();

  // Theme editor: mount re-rendered sections, and free the WebGL context of removed ones.
  document.addEventListener('shopify:section:load', (e) => mount(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll(SELECTOR).forEach((root) => {
      const inst = root.koDesigner || root.koShowcase;
      if (inst && inst.studio && inst.studio.dispose) inst.studio.dispose();
    });
  });
})();
